import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import { displayNameMapping } from "./BreadcrumbHelper";
import { Box, Typography } from "@mui/material";

const CustomBreadcrumbs = ({
  lastDisplayName,
}: {
  lastDisplayName?: string;
} = {}) => {
  const location = useLocation();
  const { pathname } = location;
  let url = "";
  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let urlParams = useQuery();
  let type = urlParams.get("type");
  let isFor = urlParams.get("isFor");
  let fd = urlParams.get("fd");
  let ed = urlParams.get("ed");

  const segments = pathname.split("/").filter(Boolean);
  const breadcrumbLink = segments.map((segment, index: number) => {
    const isLast = index === segments.length - 1;
    let displayName =
      (isLast && lastDisplayName) ||
      displayNameMapping[segment]?.name ||
      segment.replace(/-/g, " ");

    // Replace "Notification" with "Communication" for referral_doctor_opd or patient_opd with whatsapp
    if (
      (displayName === "Notification Template" ||
        displayName === "Notification Template Save") &&
      (isFor === "referral_doctor_opd" || isFor === "patient_opd") &&
      (type === "whatsapp" || type === "email")
    ) {
      displayName = displayName.replace("Notification", "Communication");
    }

    let mappedLink = displayNameMapping[segment]?.link || `/${segment}`;
    if (mappedLink.includes("{}")) {
      const replacements = [type, isFor];
      let i = 0;
      mappedLink = mappedLink.replace(/\{\}/g, () => replacements[i++] || "");
    }
    // mappedLink = mappedLink.replace(/_/g, " ");
    url += mappedLink;

    let to = url;
    if (
      !isLast &&
      fd != null &&
      ed != null &&
      !to.includes("fd=") &&
      !to.includes("ed=")
    ) {
      const separator = to.includes("?") ? "&" : "?";
      to = `${to}${separator}fd=${fd}&ed=${ed}`;
    }
    if (
      !isLast &&
      segment === "bill-summary-by-patient" &&
      !to.includes("page=")
    ) {
      const separator = to.includes("?") ? "&" : "?";
      to = `${to}${separator}page=1`;
    }

    if (isLast) {
      return (
        <Typography
          key={index}
          style={{
            fontSize: "14px",
            textDecoration: "none",
            fontWeight: "500",
            color: "inherit",
          }}
        >
          <span style={{ textTransform: "capitalize" }}>
            {/* {isFor ? isFor : ""} */}
            {isFor ? `${isFor.replace(/_/g, " ")} ` : ""}
            {displayName}
            {type ? ` (${type})` : ""}
          </span>
        </Typography>
      );
    } else {
      return (
        <Link
          key={index}
          to={to}
          style={{
            fontSize: "14px",
            textDecoration: "none",
            fontWeight: "500",
            color: "#3b75ff",
          }}
        >
          <span style={{ textTransform: "capitalize" }}>
            {displayName} {" / "}
          </span>
        </Link>
      );
    }
  });

  // const breadcrumbLink = segments.map((segment, index: number) => {
  //   let displayName = "";

  //   let displayName2 = segment?.split("-")?.join(" ");

  //   displayName = displayNameMapping[segment]?.name || displayName2;

  //   url += displayNameMapping[segment]?.link || `/${segment}`;

  //   const isLast = segments.length - 1;

  //   if (index === isLast) {
  //     return (
  //       <Typography
  //         key={index}
  //         style={{
  //           fontSize: "14px",
  //           textDecoration: "none",
  //           fontWeight: "500",
  //           color: "black",
  //         }}>
  //         <span style={{ textTransform: "capitalize" }}>{isFor ? isFor : ''} {displayName} {type ? ' (' + type + ')' : ''}</span>
  //       </Typography>
  //     );
  //   } else {
  //     return (
  //       <Link
  //         key={index}
  //         to={url}
  //         style={{
  //           fontSize: "14px",
  //           textDecoration: "none",
  //           fontWeight: "500",
  //           color: "#3b75ff",
  //         }}>
  //         <span style={{ textTransform: "capitalize" }}>
  //           {displayName} {" / "}
  //         </span>
  //       </Link>
  //     );
  //   }
  // });

  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.5,
        flexWrap: "wrap",
      }}
    >
      {breadcrumbLink}
    </Box>
  );
};

export default CustomBreadcrumbs;
